// extracted by mini-css-extract-plugin
module.exports = {"root":"ResetPasswordView_root__1pNpg"};